// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"cf83ab7a","4130":"cc2a9b19","6302":"299ac231","8187":"299ac231","9343":"299ac231","9658":"299ac231"}[chunkId] + ".chunk.css";
};